import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { Brands } from './Brands.types';

export function useBrandsData(): Page<Brands>['templateFields'] {
  return useCurrentPage<Page<Brands>>().templateFields;
}
